import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable, of} from "rxjs";
import { env } from "@environments/environment";
import {MedicinesMedicalDevicesInterface} from "@app/quarantine/intrfaces/quarantine.interface";

export type FilterInitDataKeys =
  | "treatment-program"
  | "sponsor"
  | "institution-tax"
  | "nomenclature"
  | "due-date"
  | "balance-quantity"
  | "type"
  | "documentStatus"
  | "series"
  | "tradeName"
  | "institutionIds"
  | "tradeNameUnique"
  | "redistributionTreatmentProgram"
  | "redistributionStatus"
  | "redistributionSeries"
  | "registerOfAvailableSeries"
  | "redistributionOferDueDate"
  | "date-range"
  | "";

export const SortKeys: { [key: string]: string } = {
  "due-date": "dueDate",
  nomenclature: "mnnName",
  "balance-quantity": "balanceQuantity",
};
export const DoubleFilterKeys = ["due-date", "balance-quantity", 'date-range'];
export const singleFilterKeys = ['series'];
export const FilterKeys = {
  treatmentProgram: "treatment-program",
  sponsoredBy: "sponsor",
  organizationCode: "institution-tax",
  mnnName: "nomenclature",
  dueDate: "due-date",
  balanceQuantity: "balance-quantity",
  type: "type",
  releaseForm: "release-form",
  tradeNameUnique: "tradeName",
  redistributionStatus: "status",
  redistributionTreatmentProgram: 'direction',
  redistributionSeries: 'series',
  registerOfAvailableSeries: 'registerOfAvailableSeries',
};
export const ReddistributionFilterKeys = {
  mnnName: "nomenclature",
  tradeName: 'tradeNameUnique',
  status: 'redistributionStatus',
  treatmentProgram: 'redistributionTreatmentProgram',
  series: 'redistributionSeries',
  dueDate: 'date-range',
};

export const statusTypes:{ [key: string]: string } = {
  'Чернетка': 'DRAFT',
  'Підтверджено': 'CONFIRMED',
  'Скасовано': 'CANCELLED'
};

export const redistributionStatusTypes:{ [key: string]: string } = {
  'Чернетка': 'DRAFT',
  'Актуально': 'ACTIVE',
  'Виконано': 'COMPLETE',
  'Скасовано': 'CANCELLED',
  'Протерміновано': 'EXPIRED',
};

@Injectable({
  providedIn: "root",
})
export class FilterService {
  private coreUrl = "http://localhost:3000";

  constructor(private http: HttpClient) {}

  getInitialFilterData(key: FilterInitDataKeys): Observable<any> | undefined {
    if (!key.length) return;
    if (key === "type") {
      return this.http.get<any>(
        env.apiUrl + "/accounting/v1/nomenclature/type"
      );
    }
    if (key === "tradeNameUnique") {
      return this.http.get<any>(
          env.apiUrl + "/accounting/v1/medicines-medical-devices/filter/trade-name/unique"
      );
    }
    if (key === "redistributionTreatmentProgram") {
      return this.http.get<any>(
          env.apiUrl + "/accounting/v1/redistribution-offer/medicine-medical-device/filter/direction"
      );
    }
    if (key === "redistributionSeries") {
      return this.http.get<any>(
          env.apiUrl + "/accounting/v1/redistribution-offer/medicine-medical-device/filter/series"
      );
    }
    if (key === "registerOfAvailableSeries") {
      return this.http.get<any>(
          env.apiUrl + "/accounting/v1/medicines-medical-devices/filter/series"
      );
    }
    return this.http.get<any>(
      env.apiUrl + "/accounting/v1/medicines-medical-devices/filter/" + key
    );
  }
  
  getMedicinesMedicalDevices(config: {organizationId?: string, tradeName: string}): Observable<MedicinesMedicalDevicesInterface> {
    let url = env.apiUrl + '/accounting/v1/medicines-medical-devices/filter/trade-name?';
    
    const params = new URLSearchParams(config).toString();
    return this.http.get<MedicinesMedicalDevicesInterface>(url + params)
  }
}
